import { useState, useEffect } from 'react';
import 'react-quill/dist/quill.snow.css';
import { getSchool } from '../../utils/functions';
import CSIPHighSchoolEdit from '../CSIPHightSchoolEdit/CSIPHighSchoolEdit';
import CSIPMiddleSchoolEdit from '../CSIPMiddleSchoolEdit/CSIPMiddleSchoolEdit';
import CSIPElementarySchoolEdit from '../CSIPElementarySchoolEdit/CSIPElementarySchoolEdit';
import CSIP8KSchoolEdit from '../CSIP8KSchoolEdit/CSIP8KSchoolEdit';
import React from 'react';

export default function CSIPEdit(props) {
    const [school, setSchool] = useState({});

    useEffect(() => {
        const getAndSetSchool = async () => {
            const response = await getSchool(props.match.params.schoolId);
            setSchool(response);
        };

        getAndSetSchool();
    }, []);

    return (
        <>
            {school?.school_type === 'High' && <CSIPHighSchoolEdit school={school} />}

            {school?.school_type === 'Middle' && <CSIPMiddleSchoolEdit school={school} />}

            {school?.school_type === 'Elementary' && <CSIPElementarySchoolEdit school={school} />}

            {school?.school_type === 'K-8' && <CSIP8KSchoolEdit school={school} />}
        </>
    );
}
